import { useState } from 'react';
import {Container } from 'react-bootstrap';
import Login from '../auth/login';
import RecoverPassword from '../auth/recoverpassword';
import { useLocation } from 'react-router-dom';
import styles from '../styles/auth-pages.module.css';

function AuthLayout(){
    const [recoverPassword, showRecoverPassword] = useState(false);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const returnToParam = searchParams.get("returnTo");
    const returnUrl = returnToParam && returnToParam !== "" ? returnToParam : "/";

    return(
        <Container fluid className={styles.authViewport}>
            <div className={styles.authShell}>
                <div className={styles.formColumn}>
                    {recoverPassword
                        ? <RecoverPassword showLogin={() => showRecoverPassword(false)} />
                        : <Login passwordReset={location.state ? location.state.passwordset : false} returnUrl={returnUrl} showRecoverPassword={() => showRecoverPassword(true)}/>}
                </div>
            </div>
        </Container>
    )
}
export default AuthLayout;

